import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FC, useRef } from 'react';
import VimeoPlayer from '@/components/shared/VimeoPlayer';
import { useVimeoViewportPlayback } from '@/hooks/useVimeoViewportPlayback';
import { StrapiImage, StrapiVideo } from '@/types/common';
import css from '../style.module.scss';
interface Props {
  preview?: StrapiImage | StrapiVideo;
  videoUrl?: string;
  videoThumbnailUrl?: string;
  alt?: string;
  shouldLoadVideo?: boolean;
}
const MediaInfoPreview: FC<Props> = t0 => {
  const $ = _c(11);
  const {
    preview,
    videoUrl,
    videoThumbnailUrl,
    alt,
    shouldLoadVideo
  } = t0;
  const previewRef = useRef(null);
  const vimeoPlaying = useVimeoViewportPlayback(previewRef);
  if (videoUrl) {
    let t1;
    if ($[0] !== videoThumbnailUrl || $[1] !== videoUrl || $[2] !== vimeoPlaying) {
      t1 = <div ref={previewRef} className={css.image}><VimeoPlayer url={videoUrl} thumbnailUrl={videoThumbnailUrl} playing={vimeoPlaying} /></div>;
      $[0] = videoThumbnailUrl;
      $[1] = videoUrl;
      $[2] = vimeoPlaying;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== preview) {
    t1 = preview && "mime" in preview && preview.mime.startsWith("video");
    $[4] = preview;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const isVideo = t1;
  let t2;
  if ($[6] !== alt || $[7] !== isVideo || $[8] !== preview?.url || $[9] !== shouldLoadVideo) {
    t2 = <div className={css.image}>{isVideo ? <video muted={true} loop={true} playsInline={true} preload="none" width={750} height={420}>{shouldLoadVideo ? <><source src={preview?.url ?? ""} type="video/mp4" />Your browser does not support the video tag.</> : null}</video> : <Image preload={true} width={750} height={420} quality={100} src={preview?.url ?? ""} alt={alt ?? "Work Image"} />}</div>;
    $[6] = alt;
    $[7] = isVideo;
    $[8] = preview?.url;
    $[9] = shouldLoadVideo;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default MediaInfoPreview;